const SiteHeaderSetup = () => {
  const components = document.querySelectorAll('[data-component-site-header]');
  const siteWrapper = document.querySelector('.site-wrapper');

  components.forEach((component) => {
    const menuItemsWithChildren = component.querySelectorAll('.menu-item-has-children');
    const navigationToggleButton = component.querySelector('.navigation-toggle-button');
    const primaryNavigation = component.querySelector('.primary-navigation');
    const navigation = component.querySelector('.navigation');

    let isNavigationOpen = false;
    let isDesktopNavigationSetup = false;
    let isMobileNavigationSetup = false;
    let showNavigationTimeline = gsap.timeline();
    let hideNavigationTimeline = gsap.timeline();

    const setupSubMenusForMobile = () => {
      menuItemsWithChildren.forEach((item) => {
        item.querySelector('a').addEventListener('click', (event) => {
          event.preventDefault();

          if (item.classList.contains('is-active')) {
            item.classList.remove('is-active');
          } else {
            item.classList.add('is-active');
          }

          const subMenu = item.querySelector('.sub-menu');

          gsap.to(subMenu, {
            height: item.classList.contains('is-active') ? 'auto' : 0,
            ease: 'power3.out',
            duration: 0.5,
          });
        });
      });
    };

    const setupSubMenusForDesktop = () => {
      menuItemsWithChildren.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          item.classList.remove('is-active');
          const subMenu = item.querySelector('.sub-menu');

          gsap.to(subMenu, {
            autoAlpha: 1,
            y: 0,
            ease: 'power3.out',
            duration: 0.4,
          });
        });

        item.addEventListener('mouseleave', () => {
          item.classList.remove('is-active');
          const subMenu = item.querySelector('.sub-menu');

          gsap.to(subMenu, {
            autoAlpha: 0,
            y: -20,
            ease: 'power3.out',
            duration: 0.4,
          });
        });
      });
    };

    const showSiteNavigation = (isImmediate = false) => {
      navigationToggleButton.classList.add('is-active');
      if(!isImmediate) isNavigationOpen = true;
      if (hideNavigationTimeline) hideNavigationTimeline.kill();
      showNavigationTimeline = gsap.timeline();
      showNavigationTimeline.to(primaryNavigation, {
        xPercent: 0,
        duration: isImmediate ? 0 : 0.5,
        ease: 'power3.out'
      });
    };

    const hideSiteNavigation = (isImmediate = false) => {
      navigationToggleButton.classList.remove('is-active');
      isNavigationOpen = false;
      if (showNavigationTimeline) showNavigationTimeline.kill();
      hideNavigationTimeline = gsap.timeline();
      hideNavigationTimeline.to(primaryNavigation, {
        xPercent: 100,
        duration: isImmediate ? 0 : 0.5,
        ease: 'power3.out'
      });
    };

    navigationToggleButton.addEventListener('click',  () => {
      if (navigationToggleButton.classList.contains('is-active')) {
        hideSiteNavigation();
      } else {
        showSiteNavigation();
      }
    });

    const switchToDesktopLayout = () => {
      if (isDesktopNavigationSetup) return;
      setupSubMenusForDesktop();
      showSiteNavigation(true);
      isDesktopNavigationSetup = true;
      isMobileNavigationSetup = false;
    };
    const switchToMobileLayout = () => {
      if (isMobileNavigationSetup) return;
      hideSiteNavigation(true);
      setupSubMenusForMobile();
      isDesktopNavigationSetup = false;
      isMobileNavigationSetup = true;
    };

    const handleWindowResize = () => {
      const isProgramPage = document.body.classList.contains('page-template-page-programma');

   

      if(window.innerWidth >= 1024) {
        switchToDesktopLayout();
        if (!isProgramPage) {
          siteWrapper.style.paddingTop = `${component.querySelector('.content-wrapper').offsetHeight}px`;
        }
      } else {
        siteWrapper.style.paddingTop = `${component.querySelector('.content-wrapper').offsetHeight + 30}px`;
        switchToMobileLayout();
      }
    };

    const handleHeaderPosition = (currentScrollTop) => {
      if (isNavigationOpen) return;
      if (currentScrollTop > 10) {
        if (!component.classList.contains('is-scroll-header')) {
          component.classList.add('is-scroll-header');
        }
      } else {
        if (currentScrollTop === 0) {
          if (component.classList.contains('is-scroll-header')) {
            component.classList.remove('is-scroll-header');
          }
        }
      }
    };

    window.addEventListener('scroll', () => {
      handleHeaderPosition(currentScrollTop);
    });

    window.addEventListener('resize', () => handleWindowResize());
    handleWindowResize();
  });
};

SiteHeaderSetup();